<template>
    <div class="w-sliding-tabs">
        <div class="w-sliding-tabs__inner" :style="innerStyle">
            <span class="w-sliding-tabs__indicator"></span>
            <div class="w-sliding-tabs__buttons" role="group">
                <el-button
                    v-for="item in options"
                    :key="item.value"
                    class="w-sliding-tabs__button"
                    size="large"
                    :type="modelValue === item.value ? 'primary' : ''"
                    @click="select(item.value)"
                >
                    {{ item.label }}
                </el-button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "SlidingTabs",
    props: {
        modelValue: {
            type: [String, Number, Boolean],
            default: "",
        },
        options: {
            type: Array,
            default: () => [],
        },
        itemWidth: {
            type: Number,
            default: 108,
        },
        gap: {
            type: Number,
            default: 4,
        },
        activeShadow: {
            type: String,
            default: "none",
        },
    },
    emits: ["update:modelValue", "change"],
    watch: {
        activeIndex() {
            this.scrollActiveIntoView();
        },
    },
    computed: {
        activeIndex() {
            return Math.max(
                this.options.findIndex((item) => item.value === this.modelValue),
                0
            );
        },
        innerStyle() {
            return {
                "--sliding-tabs-item-width": `${this.itemWidth}px`,
                "--sliding-tabs-offset": `${this.activeIndex * (this.itemWidth + this.gap)}px`,
                "--sliding-tabs-gap": `${this.gap}px`,
                "--sliding-tabs-active-shadow": this.activeShadow,
            };
        },
    },
    methods: {
        select(value) {
            if (value === this.modelValue) return;
            this.$emit("update:modelValue", value);
            this.$emit("change", value);
        },
        scrollActiveIntoView() {
            this.$nextTick(() => {
                const scroller = this.$el;
                const button = scroller?.querySelector(".el-button--primary");
                if (!button) return;
                button.scrollIntoView({
                    behavior: "smooth",
                    block: "nearest",
                    inline: "nearest",
                });
            });
        },
    },
};
</script>

<style lang="less">
.w-sliding-tabs {
    .flex;
    justify-content: flex-start;
    width: 100%;
    min-width: 0;
    max-width: 100%;
    overflow-x: auto;
    overflow-y: hidden;
    overscroll-behavior-x: contain;
    scrollbar-width: thin;

    .w-sliding-tabs__inner {
        position: relative;
        flex: 0 0 auto;
        padding: 4px;
        border: 1px solid #d0d5dd;
        border-radius: 10px;
        background: #fff;
        box-shadow: 0 1px 2px rgba(16, 24, 40, 0.04);
    }

    .w-sliding-tabs__indicator {
        position: absolute;
        top: 4px;
        bottom: 4px;
        left: 4px;
        z-index: 0;
        width: var(--sliding-tabs-item-width);
        border-radius: 8px;
        background: var(--el-color-primary);
        transform: translateX(var(--sliding-tabs-offset));
        transition: transform 0.22s ease;
        box-shadow: var(--sliding-tabs-active-shadow);
        pointer-events: none;
    }

    .w-sliding-tabs__buttons {
        position: relative;
        z-index: 1;
        display: flex;
        gap: var(--sliding-tabs-gap);
    }

    .w-sliding-tabs__button {
        min-width: var(--sliding-tabs-item-width);
        flex: 0 0 var(--sliding-tabs-item-width);
        margin: 0 !important;
        border: none;
        border-radius: 8px !important;
        background: transparent;
        box-shadow: none !important;
    }

    .w-sliding-tabs__button.el-button--primary {
        border-color: transparent;
        background: transparent;
    }
}
</style>
